module.exports = __webpack_public_path__ + "img/ColoredSpace6.fecc466b.jpg";